(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracAdminUserAccountDialogController', NasracAdminUserAccountDialogController);

    NasracAdminUserAccountDialogController.$inject = ['$timeout','$state', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'NasracAdminUserAccount', 'NasracAdminCustomerAccount'];

    function NasracAdminUserAccountDialogController ($timeout, $state, $scope, $stateParams, $uibModalInstance, entity, NasracAdminUserAccount, NasracAdminCustomerAccount) {
        var vm = this;

        vm.nasracAdminUserAccount = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.nasracadmincustomeraccounts = NasracAdminCustomerAccount.query();
        vm.nasracAdminUserAccount.securityRoles = angular.fromJson(vm.nasracAdminUserAccount.securityRoles);
        vm.securityRolesMap = NasracAdminUserAccount.get_security_roles();
        vm.isSiteIdEnable = $state.$current.data.isSiteIdEnable;

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            if(vm.nasracAdminUserAccount.userFirstName === undefined || vm.nasracAdminUserAccount.userFirstName === null){
                vm.nasracAdminUserAccount.userFirstName = '';
            }
            vm.isSaving = true;
            if (vm.nasracAdminUserAccount.id !== null) {
                NasracAdminUserAccount.update(vm.nasracAdminUserAccount, onSaveSuccess, onSaveError);
            } else {
                NasracAdminUserAccount.save(vm.nasracAdminUserAccount, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('nasracApp:nasracAdminUserAccountUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastLoginTime = false;
        vm.datePickerOpenStatus.lastActivityTime = false;
        vm.datePickerOpenStatus.lastPasswordChangeTime = false;
        vm.datePickerOpenStatus.lastLockOutTime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }



        vm.models = [
            {listName: "All Security Roles", items: [], dragging: false},
            {listName: "Selected Roles", items: [], dragging: false}
          ];

        vm.securityRolesMap.$promise.then(function(data) {
        	angular.forEach(data, function(role) {
        		if (!vm.nasracAdminUserAccount.securityRoles.some(function(e){ return e.id == role.id;})) {
        				vm.models[0].items.push({label: role.securityRoleName, id: role.id});
        			} else {
        				vm.models[1].items.push({label: role.securityRoleName, id: role.id});
        			}

          	});
        });


        vm.getSelectedItemsIncluding = function(list, item) {
            item.selected = true;
            return list.items.filter(function(item) { return item.selected; });
          };

          /**
           * We set the list into dragging state, meaning the items that are being
           * dragged are hidden. We also use the HTML5 API directly to set a custom
           * image, since otherwise only the one item that the user actually dragged
           * would be shown as drag image.
           */
          vm.onDragstart = function(list, event) {
             list.dragging = true;
             /*if (event.dataTransfer.setDragImage) {
               var img = new Image();
               img.src = 'framework/vendor/ic_content_copy_black_24dp_2x.png';
               event.dataTransfer.setDragImage(img, 0, 0);
             }*/
          };

          /**
           * In the dnd-drop callback, we now have to handle the data array that we
           * sent above. We handle the insertion into the list ourselves. By returning
           * true, the dnd-list directive won't do the insertion itself.
           */
          vm.onDrop = function(list, items, index) {
            angular.forEach(items, function(item) { item.selected = false; });
            list.items = list.items.slice(0, index)
                        .concat(items)
                        .concat(list.items.slice(index));
            return true;
          }

          /**
           * Last but not least, we have to remove the previously dragged items in the
           * dnd-moved callback.
           */
          vm.onMoved = function(list) {
            list.items = list.items.filter(function(item) { return !item.selected; });
            vm.nasracAdminUserAccount.securityRoles = vm.models[1].items;
          };




    }
})();
